import { LOCALE_ID } from '@angular/core';
import { APP_INITIALIZER, ApplicationConfig, provideBrowserGlobalErrorListeners, provideZonelessChangeDetection } from '@angular/core';
import { provideRouter, withHashLocation } from '@angular/router';
import { HttpClientModule, provideHttpClient, withFetch, withInterceptors } from '@angular/common/http';
import { provideAnimations } from '@angular/platform-browser/animations';
import { MessageService } from '@progress/kendo-angular-l10n';

import { routes } from './app.routes';
import { tokenInterceptor } from './core/auth/interceptors/auth.interceptor';

import { GlobalKendoMessageService } from './core/localization/global-messages.es-ar';
import { SecurityService } from './core/services/security.service';
import { AuthService } from './core/auth/services/auth.service';
import { appInitializerFactory } from './app.initializer';

export const appConfig: ApplicationConfig = {
  providers: [
    provideBrowserGlobalErrorListeners(),
    provideZonelessChangeDetection(),
    provideRouter(routes, withHashLocation()),
    provideRouter(routes),
    provideHttpClient(
      withFetch(),
      withInterceptors([tokenInterceptor])
    ),
    provideAnimations(),
    // AuthService,
    // SecurityService,
    {
      provide: APP_INITIALIZER,
      useFactory: appInitializerFactory,
      deps: [AuthService, SecurityService],
      multi: true
    },
    { provide: LOCALE_ID, useValue: 'es-AR' },
    { provide: MessageService, useClass: GlobalKendoMessageService },
  ]
};
